module.exports = svg => {
    return svg.node.getBoundingClientRect().width / svg.attr('viewBox').width;
};


// WEBPACK FOOTER //
// ./js/viscom/kaspersky/risksOverview/svgAnim/getSvgToHtmlRatio.js